import React from 'react';
import { Grid, GridItem } from '@chakra-ui/react';
import { useFormContext } from 'react-hook-form';
import { InputField } from 'app/components/Core/ChakraInputField/InputField';
import { useIsMobile } from 'app/utils/hooks';
import { ProfileFormData } from '../ProfileForm/types';

export const ProfilePersonalSection: React.FC = () => {
  const isMobile = useIsMobile();
  const templateColumns = isMobile ? '1fr' : 'repeat(6, 1fr)';
  const colSpan = isMobile ? 3 : 2;

  const {
    formState: { errors },
    register,
  } = useFormContext<ProfileFormData>();

  return (
    <Grid templateColumns={templateColumns} gap={4}>
      <GridItem colSpan={colSpan}>
        <InputField
          label="First name"
          data-testid="first-name"
          {...register('firstName')}
          isInvalid={Boolean(errors.firstName)}
          errorMessage={errors.firstName?.message}
        />
      </GridItem>
      <GridItem colSpan={colSpan}>
        <InputField
          label="Middle name"
          data-testid="middle-name"
          {...register('middleName')}
          isInvalid={Boolean(errors.middleName)}
          errorMessage={errors.middleName?.message}
        />
      </GridItem>
      <GridItem colSpan={colSpan}>
        <InputField
          label="Last name"
          data-testid="last-name"
          {...register('lastName')}
          isInvalid={Boolean(errors.lastName)}
          errorMessage={errors.lastName?.message}
        />
      </GridItem>
      <GridItem colSpan={colSpan}>
        <InputField
          label="Display name"
          data-testid="display-name"
          {...register('displayName')}
          isInvalid={Boolean(errors.displayName)}
          errorMessage={errors.displayName?.message}
        />
      </GridItem>
      <GridItem colSpan={colSpan}>
        <InputField
          label="Artist name"
          data-testid="artist-name"
          {...register('artistName')}
          isInvalid={Boolean(errors.artistName)}
          errorMessage={errors.artistName?.message}
        />
      </GridItem>
    </Grid>
  );
};
